export var InAppEvents;
(function (InAppEvents) {
    InAppEvents["MessageOpened"] = "in-app:message-opened";
    InAppEvents["MessageDismissed"] = "in-app:message-dismissed";
    InAppEvents["MessageError"] = "in-app:message-error";
    InAppEvents["MessageAction"] = "in-app:message-action";
})(InAppEvents || (InAppEvents = {}));
export var allEvents = Object.values(InAppEvents);
export var JourneysEvents;
(function (JourneysEvents) {
    JourneysEvents["Metric"] = "Report Delivery Event";
    JourneysEvents["Content"] = "Report Content Event";
    JourneysEvents["Opened"] = "opened";
    JourneysEvents["Clicked"] = "clicked";
    JourneysEvents["ViewedContent"] = "viewed_content";
    JourneysEvents["ClickedContent"] = "clicked_content";
})(JourneysEvents || (JourneysEvents = {}));
export var ContentType = 'in_app_content';
export function newEvent(type, detail) {
    return new CustomEvent(type, { detail: detail });
}
export function gistToCIO(gistEvent) {
    switch (gistEvent) {
        case 'messageShown':
            return InAppEvents.MessageOpened;
        case 'messageDismissed':
            return InAppEvents.MessageDismissed;
        case 'messageError':
            return InAppEvents.MessageError;
        case 'messageAction':
            return InAppEvents.MessageAction;
        default:
            return "";
    }
}
//# sourceMappingURL=events.js.map